export const boardMembers2021 = 23574
export const boardMembers2022 = 25084
export const boardMembers2023 = 25122
export const boardMembers2024 = 24607
export const boardMembers2025 = 23354
export const boardMembers2026 = 20404
export const boardMembersTotal = 44022
